export default {
  generic_error: 'Ceva a mers greșit',
  address_not_found:
    'Ne pare rău, nu am găsit acea adresă. Încearcă din nou introducând mai întâi strada în câmpul de căutare.',
  internal_error:
    'Din păcate, a apărut o problemă neașteptată cu comanda ta, echipa noastră tehnică lucrează deja la rezolvare 🛠️.',
};
